import React, { useEffect, useState } from "react";
import AdminNavbar from "../Component/AdminNavbar";
export const AdminUsers = () => {

    const [users, setUsers] = useState([]);

    useEffect(() => {

        fetch(`${process.env.REACT_APP_API_URL}/auth/users`)
            .then((res) => res.json())
            .then((data) => {
                setUsers(data);
            });

    }, []);

    return (
        <div className="container mt-5">

            <AdminNavbar />

            <h2>Admin Users</h2>

            <table className="table table-bordered mt-4">

                <thead>
                <tr>
                    <th>ID</th>
                    <th>Email</th>
                    <th>Role</th>
                </tr>
                </thead>

                <tbody>
                {
                    users.map((user) => (
                        <tr key={user.userid}>
                            <td>{user.userid}</td>
                            <td>{user.email}</td>
                            <td>{user.role}</td>
                        </tr>
                    ))
                }
                </tbody>

            </table>

        </div>
    );
};